export enum CardType {
  DEPOSIT = 'deposit',
  THANK_YOU = 'thank-you',
  FAILED = 'failed',
}

export enum DepositVariant {
  'quick',
  'normal',
}

export enum MOBILE_PAYMENT {
  DEPOSIT_REQUEST_SENT = 'DEPOSIT_REQUEST_SENT',
}

export enum DEPOSIT_CONFIRMATION_TYPE {
  THANK_YOU_CARD = 'THANK_YOU_CARD',
  APP_NOTIFICATION = 'APP_NOTIFICATION',
  WITHDRAWAL = 'WITHDRAWAL',
}

export enum DEPOSIT_TYPE {
  PENDING = 0,
  FAILED = -1,
}

export enum WALLET_UPDATE_TYPE {
  DEPOSIT = 1,
  WITHDRAW = 2,
  BET = 3,
  CASHOUT = 4,
}

export enum CURRENCY_SYMBOL {
  EURO = '€',
  POUND = '£',
  DOLLAR = '$',
  INDIAN_RUPEE = '₹',
  KENYAN_SHILLING = 'KSh',
  BRAZILIAN_REAL = 'R$',
  CANADIAN_DOLLAR = 'C$',
  NEW_ZEALAND_DOLLAR = 'NZ$',
  SWISS_FRANC = '₣',
}

export enum CURRENCY_NAME {
  EURO = 'Euro',
  POUND = 'Pound',
  DOLLAR = 'Dollar',
  INDIAN_RUPEE = 'Indian Rupee',
  KENYAN_SHILLING = 'Kenyan Shilling',
  BRAZILIAN_REAL = 'Brazilian Real',
  CANADIAN_DOLLAR = 'Canadian Dollar',
  NEW_ZEALAND_DOLLAR = 'New Zealand Dollar',
  SWISS_FRANC = 'Swiss Franc',
}

export enum CURRENCY_ISO {
  BRITISH_POUND = 'GBP',
  EURO = 'EUR',
  CANADIAN_DOLLAR = 'CAD',
  INDIAN_RUPEE = 'INR',
  KENYAN_SHILLING = 'KES',
  NEW_ZEALAND_DOLLAR = 'NZD',
  BRAZILIAN_REAL = 'BRL',
  UNITED_STATES_DOLLAR = 'USD',
  SWISS_FRANC = 'CHF',
}

export enum PAYMENT_METHODS_TRANSACTION_TYPE_ID {
  DEPOSIT = 0,
  WITHDRAWAL = 1,
}

export enum PAYMENT_PROVIDER_TYPE_ID {
  CASHIER = 1,
  API = 2,
  EWALLET = 3,
}

export enum TRANSACTION_TYPES {
  DEPOSIT = 'DEPOSIT',
  WITHDRAWAL = 'WITHDRAWAL',
  TICKET_PLACED = 'TICKET PLACED',
  TICKET_RESOLVED = 'TICKET RESOLVED',
  TICKET_WON = 'TICKET WON',
  TICKET_LOST = 'TICKET LOST',
  TICKET_VOIDED = 'TICKET VOIDED',
  RECURRING_DEPOSIT = 'RECURRING DEPOSIT',
  TICKER_UNRESOLVED = 'TICKET UNRESOLVED',
  TICKET_CANCELLED = 'TICKET CANCELLED',
  TICKET_UNCANCELLED = 'TICKET UNCANCELLED',
  WITHDRAWAL_REJECTED = 'WITHDRAWAL REJECTED',
  CASINO_BET_PLACED = 'CASINO BET PLACED',
  CASINO_BET_WON = 'CASINO BET WON',
  ROLLBACK_CASINO_BET = 'ROLLBACK CASINO BET',
  ROLLBACK_CASINO_WIN = 'ROLLBACK CASINO WIN',
  SLOT_DEPOSIT = 'SLOT DEPOSIT',
  SLOT_WINNINGS = 'SLOT WINNINGS',
  SLOT_CANCEL_DEPOSIT = 'SLOT CANCEL DEPOSIT',
  SLOT_FREE_GAME_WON = 'SLOT FREE GAME WON',
  MANUAL_INCREASE = 'MANUAL INCREASE',
  MANUAL_DECREASE = 'MANUAL DECREASE',
  CASINO_MANUAL_INCREASE = 'CASINO MANUAL INCREASE',
  CASINO_MANUAL_DECREASE = 'CASINO MANUAL DECREASE',
  FREE_TICKET_PLACED = 'FREE TICKET PLACED',
  FREE_TICKET_WON = 'FREE TICKET WON',
  FREE_TICKET_LOST = 'FREE TICKET LOST',
  FREE_TICKET_VOIDED = 'FREE TICKET VOIDED',
  FREE_TICKET_UNRESOLVED = 'FREE TICKET UNRESOLVED',
  FREE_TICKET_RESOLVED = 'FREE TICKET RESOLVED',
  TICKET_PLACED_RESULT = 'TICKET PLACED RESULT',
  SYSTEM_REWARD = 'SYSTEM REWARD',
  BONUS_FUNDS_REMOVED = 'BONUS FUNDS REMOVED',
  BONUS_FUNDS_CONVERSION = 'BONUS FUNDS CONVERSION',
  BONUS_FUNDS_EDITED = 'BONUS FUNDS EDITED',
  BONUS_FUNDS_ADDED = 'BONUS FUNDS ADDED',
}

export enum PAYMENT_PROVIDER {
  PAYMENT_IQ = 'payment-iq', // official name for Bambora
  CPAY = 'cpay',
  NUVEI = 'nuvei', // official name for Safecharge
  ZIMPLER = 'zimpler',
}

export enum SIGNUP_OPTION {
  ZIMPLER_PNP = 36,
}

export enum PAYMENT_PROVIDER_ID {
  ZIMPLER = 8,
}

export enum PAYMENT_METHOD_ID {
  PAYPAL = 6,
}

export enum PAYMENT_METHOD_NAME {
  ZIMPLER = 'Zimpler',
}

export enum WITHDRAWAL_STATUS {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  SETTLED = 'SETTLED',
  FAILED = 'FAILED',
  FAILURE = 'FAILURE',
  CANCELLED = 'CANCELLED',
}

export enum BONUS_WALLET_STATUS {
  INCOMPLETE = 1,
  CANCELLED = 2,
  COMPLETED = 3,
  EXPIRED = 4,
}

export enum BONUS_WALLET_DISPLAY {
  SIMPLIFIED,
  DETAILED,
}
